import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { AccountNavVariantType } from 'src/domains/layouts/config/features/types';
import { ChatIcon } from 'src/domains/layouts/shared/assets/icons/ChatIcon';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { styleNavIcon } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/AccountNavigation.style';
import { withConfig } from 'src/withConfig';

const setTraderChatWrapper = (variant: AccountNavVariantType | null): SerializedStyles => {
    if (variant === AccountNavVariantType.SECONDARY) {
        return css`
            padding-left: 0;
            flex-flow: column nowrap;
        `;
    }

    return css`
        padding-left: 13px;
    `;
};


interface TraderChatWrapperPropsType {
    variant: AccountNavVariantType | null;
}

export const TraderChatWrapper = styled('div', { label: 'TraderChatWrapper' })<TraderChatWrapperPropsType>`
    ${({ variant }): SerializedStyles => setTraderChatWrapper(variant)}
    align-items: center;
    display: flex;
    justify-content: center;
    position: relative;
`;

export const TraderChatButtonFloatingWrapper = withConfig(theme => styled(Button, { label: 'TraderChatButtonFloatingWrapper' })`
    border-radius: 50%;
    bottom: 104px;
    height: 48px;
    overflow: hidden;
    padding: 0;
    position: fixed;
    right: 16px;
    text-transform: none;
    width: 48px;
    z-index: ${theme.star.zIndexGlobal.above};
    @media ${theme.star.mediaQuery.desktop} {
        bottom: 16px;
        right: 296px;
    }
`);

export const TraderChatWrapperFloating = styled(TraderChatWrapper, { label: 'TraderChatWrapperFloating' })`
    padding: 0;
`;

interface TraderChatWrapperTxtPropsType {
    variant: AccountNavVariantType | null;
}

export const TraderChatWrapperTxt = styled('span', { label: 'TraderChatWrapperTxt' })<TraderChatWrapperTxtPropsType>`
    display: ${({ variant }): string => variant === AccountNavVariantType.SECONDARY ? 'inline' : 'block'};
    line-height: 1.24;
    position: relative;
`;

export const ChatIconWrapper = styled(ChatIcon, { label: 'ChatIconWrapper' })`
    margin-right: 5px;
    ${styleNavIcon()};
`;

export const ChatIconWrapperFloating = styled(ChatIcon, { label: 'ChatIconWrapperFloating' })`
    ${styleNavIcon()};
`;

export const TraderChatCounter = withConfig(theme => styled('span', { label: 'TraderChatCounter' })`
    align-items: center;
    background-color: ${theme.star.counter.chat.bgColor};
    border-radius: 50%;
    color: ${theme.star.counter.chat.txtColor};
    display: flex;
    font-size: ${theme.star.fontSize.xSmall};
    height: 16px;
    justify-content: center;
    min-width: 16px;
    position: absolute;
    right: 6px;
    top: -9px;
`);
